var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 482.72 482.72",
    style: {
      enableBackground: "new 0 0 482.72 482.72"
    },
    xmlSpace: "preserve",
    width: 24,
    height: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M463.367 326.16a228.942 228.942 0 0 1-95.408 20.56c-128.072-.141-231.859-103.928-232-232a228.933 228.933 0 0 1 20.544-95.408L165.303 0l-19.344 8.704C57.159 48.811.073 137.201.041 234.638-.004 371.604 110.992 482.675 247.959 482.72c97.472-.063 185.883-57.174 226.016-146l8.704-19.36-19.312 8.8zM361.974 436.785C250.394 499.772 108.88 460.38 45.893 348.8S22.299 95.707 133.879 32.72a245.313 245.313 0 0 0-13.92 82c.159 136.901 111.099 247.841 248 248a245.313 245.313 0 0 0 82-13.92 231.996 231.996 0 0 1-87.985 87.985z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoon);
export default __webpack_public_path__ + "static/media/moon.e2d89de1.svg";
export { ForwardRef as ReactComponent };